package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class MealPlanDataDto(
    @SerialName("weekly_mealplan") val weeklyMealplan: List<MealPlanDayDto>,
    @SerialName("shopping_list") val shoppingList: ShoppingListDto? = null,
)

@Serializable
internal data class MealPlanDayDto(
    @SerialName("total_calories") val totalCalories: Int,
    @SerialName("meals") val meals: MealsDayDto,
)

@Serializable
internal data class MealsDayDto(
    @SerialName("breakfast") val breakfast: List<RecipeDto> = emptyList(),
    @SerialName("lunch") val lunch: List<RecipeDto> = emptyList(),
    @SerialName("dinner") val dinner: List<RecipeDto> = emptyList(),
    @SerialName("snack") val snack: List<RecipeDto> = emptyList(),
    @SerialName("drink") val drink: List<RecipeDto> = emptyList(),
)

@Serializable
internal data class RecipeDto(
    @SerialName("_id") val id: String,
    @SerialName("title") val title: String,
    @SerialName("emoji") val emoji: String,
    @SerialName("calories_per_serving_kcal") val caloriesPerServing: Int? = null,
    @SerialName("serving_weight_grams") val servingWeightGrams: Int,
    @SerialName("ingredients") val ingredients: List<IngredientDto> = emptyList(),
    @SerialName("steps") val steps: List<String> = emptyList(),
    @SerialName("nutrition_facts_per_100g") val nutritionPer100g: NutritionDto,
)

@Serializable
internal data class IngredientDto(
    @SerialName("name") val name: String,
    @SerialName("emoji") val emoji: String = "",
    @SerialName("amount") val amount: Double,
    @SerialName("unit") val unit: String,
)

@Serializable
internal data class NutritionDto(
    @SerialName("calories") val calories: Double,
    @SerialName("protein") val protein: Double,
    @SerialName("fat") val fat: Double,
    @SerialName("carbs") val carbs: Double,
    @SerialName("fiber") val fiber: Double = 0.0,
)
